import * as React from "react"
import {
    useState,
    useEffect,
    useContext
} from "react"

import UserContext from "Placements/User.context"
import logo from 'Placements/Assets/img/logo_yazigi_final.png'
import logout from 'Placements/Assets/svg/logout.svg'

type HeaderProps = {
    configs: Array<PageConfig>
    keystones: Array<string>
    onLogout: Function
    contrast: string
    reading: string
    onChangeContrast: Function
    onChangeReading: Function
}

const filterPerKeystones = (keystones: Array<string>) => ({ keystone }: PageConfig) => keystones.indexOf(keystone) > -1;

const Header = ({ configs, keystones, onLogout, contrast, reading, onChangeContrast, onChangeReading }: HeaderProps) => {

    const userContext: any = useContext(UserContext)
    const location = window.location

    const [user, setUser] = useState(null);
    const [pageTitle, setPageTitle] = useState("Teste de nível");

    useEffect(() => {
        setUser(userContext);
    }, [])

    useEffect(() => {

        if (userContext.sucessoNoLogin && userContext.usuario.Id_perfil === 1) {
            setPageTitle(userContext.nomeUnidade);
        }

    }, [userContext])

    const handleLogout = async () => {
        onLogout()
    }

    return < header className="header-home internal" >
        <div className="logo">
            <a href="#/welcome">
                <img src={logo} alt="Logo Yázigi" />
            </a>
        </div>
        <h1 className={`header-titulo ${user && user.usuario.Id_perfil == 1 ? 'admin' : ''}`}>
            {pageTitle}
        </h1>
        <div className="button-exit" onClick={() => handleLogout()}>
            <img alt="sair logout" src={logout} />
            <span>
                sair
            </span>
        </div>
    </header>

}

export default Header
